/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerPaymentSystemType } from './customerPaymentSystemType';

export interface MobileAppInfo {
  /**
   * Payment Id
   */
  id?: string | null;
  /**
   * Payment status
   */
  status?: MobileAppInfo.StatusEnum | null;
  type?: CustomerPaymentSystemType;
}
export namespace MobileAppInfo {
  export type StatusEnum =
    | 'inprocess'
    | 'success'
    | 'fail'
    | 'canceled'
    | 'error'
    | 'authorized';
  export const StatusEnum = {
    Inprocess: 'inprocess' as StatusEnum,
    Success: 'success' as StatusEnum,
    Fail: 'fail' as StatusEnum,
    Canceled: 'canceled' as StatusEnum,
    Error: 'error' as StatusEnum,
    Authorized: 'authorized' as StatusEnum
  };
}
